function HelpCenterIcon({ size = 24, fill = '#465364' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={fill}
        d='M12.002 3a9 9 0 00-9 8.999c0 1.34.3 2.62.83 3.759.21.44.21.95.06 1.42l-.84 2.5c-.26.78.49 1.53 1.27 1.27l2.5-.84c.47-.15.98-.15 1.42.06 1.14.53 2.42.83 3.76.83a8.999 8.999 0 100-17.998zm.018 13.5a1.005 1.005 0 01-1.005-1c0-.552.444-1 .995-1h.01a1 1 0 110 2zm1.325-3.949c-.556.369-.632.557-.635.564a.767.767 0 01-.712.496.722.722 0 01-.245-.042.739.739 0 01-.463-.934c.203-.601.796-1.049 1.225-1.333.636-.422.643-.851.593-1.137a1.139 1.139 0 00-.897-.896 1.13 1.13 0 00-1.335 1.106.75.75 0 01-1.5 0c0-.778.342-1.51.939-2.011.596-.5 1.38-.709 2.157-.573a2.645 2.645 0 012.114 2.114c.184 1.052-.257 1.992-1.24 2.646z'
      />
    </svg>
  );
}

export default HelpCenterIcon;
